// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"280":"67057937","443":"63532cdd","494":"d0e498ab","555":"41b7f5c3"}[chunkId] + ".css";
};